// Microchip helpers shared by the QR and RFID scanners.
// Accepted QR payloads: the owner's Vetproof QR (https://<site>/scan?chip=…), "vetproof:chip:<digits>",
// or a bare ISO 11784 number (15 digits; 9–15 accepted for older chips).

export function parseChipPayload(text: string): string | null {
  const t = text.trim();
  try {
    const chip = new URL(t).searchParams.get("chip");
    if (chip) return clean(chip);
  } catch {
    /* not a URL */
  }
  const m = t.match(/^vetproof:chip:([\d\s-]+)$/i);
  return clean(m ? m[1] : t);
}

function clean(v: string): string | null {
  const d = v.replace(/[\s-]/g, "");
  return /^\d{9,15}$/.test(d) ? d : null;
}

/** "941000029159723" → "941 000 029 159 723" */
export const formatChip = (chip: string) => chip.replace(/(\d{3})(?=\d)/g, "$1 ");

/** The URL encoded in an owner's QR code — also opens the scanner directly from a phone's camera app. */
export const chipUrl = (chip: string) => `${location.origin}/scan?chip=${chip}`;

/** ISO 11784: the first 3 digits are a country code (ISO 3166) or a 900–998 manufacturer code. */
export function chipOrigin(chip: string): string {
  if (chip.length !== 15) return "Legacy / non-ISO chip";
  const code = Number(chip.slice(0, 3));
  if (code >= 900 && code <= 998) return `Manufacturer code ${code}`;
  const countries: Record<number, string> = { 616: "Poland", 840: "United States", 276: "Germany", 826: "United Kingdom", 250: "France", 124: "Canada" };
  return countries[code] ? `Country code ${code} · ${countries[code]}` : `Country code ${code}`;
}

/** Short confirmation beep + vibration, like a handheld scanner. */
export function scanFeedback() {
  try {
    navigator.vibrate?.(80);
    const ctx = new AudioContext();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.frequency.value = 1760;
    gain.gain.setValueAtTime(0.12, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.15);
    osc.connect(gain).connect(ctx.destination);
    osc.start();
    osc.stop(ctx.currentTime + 0.16);
    osc.onended = () => ctx.close();
  } catch {
    /* audio not available */
  }
}
